import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _typeof from "@babel/runtime-corejs3/helpers/esm/typeof";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context6, _context7; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context6 = ownKeys(Object(source), !0)).call(_context6, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context7 = ownKeys(Object(source))).call(_context7, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _flatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat";
import _Object$entries from "@babel/runtime-corejs3/core-js/object/entries";
import _Symbol$toPrimitive from "@babel/runtime-corejs3/core-js/symbol/to-primitive";

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[_Symbol$toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

import React from "react";
export var withClasses = function withClasses(defaultCssModule) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$propName = _ref.propName,
      propName = _ref$propName === void 0 ? 'classes' : _ref$propName;

  var decorator = function decorator(Component) {
    var ComponentWithCSSModule = function ComponentWithCSSModule(_ref2) {
      var _context;

      var givenClasses = _ref2[propName],
          props = _objectWithoutProperties(_ref2, _mapInstanceProperty(_context = [propName]).call(_context, _toPropertyKey));

      var classes = givenClasses || defaultCssModule;
      var finalCssModules = classes;

      if (typeof classes === 'function') {
        finalCssModules = classes(defaultCssModule);
      }

      var newProps = _objectSpread(_objectSpread({}, props), {}, _defineProperty({}, propName, finalCssModules));

      return /*#__PURE__*/React.createElement(Component, newProps);
    };

    ComponentWithCSSModule.displayName = "WithCSSModule(".concat(Component.displayName || Component.name || 'Unknown', ")");
    return ComponentWithCSSModule;
  };

  return decorator;
};

var replaceClassNameReducer = function replaceClassNameReducer(_, newClassName) {
  return newClassName;
};

var combineClassNameReducer = function combineClassNameReducer() {
  var _context2;

  var previousClassName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var newClassName = arguments.length > 1 ? arguments[1] : undefined;
  return _concatInstanceProperty(_context2 = "".concat(previousClassName, " ")).call(_context2, newClassName);
};

var createNewCssModule = function createNewCssModule(defaultCssModule, newCssModule, classNameReducer) {
  var _context3;

  var finalCssModule = _objectSpread({}, defaultCssModule);

  _forEachInstanceProperty(_context3 = _Object$keys(newCssModule)).call(_context3, function (classIdentifier) {
    var previousClassName = finalCssModule[classIdentifier];
    var newClassName = newCssModule[classIdentifier];
    finalCssModule[classIdentifier] = classNameReducer(previousClassName, newClassName);
  });

  return finalCssModule;
};

export var compose = function compose(newCssModule) {
  var composeMapper = function composeMapper(defaultCssModule) {
    return createNewCssModule(defaultCssModule, newCssModule, combineClassNameReducer);
  };

  return composeMapper;
};
export var replace = function replace(newCssModule) {
  var replaceMapper = function replaceMapper(defaultCssModule) {
    return createNewCssModule(defaultCssModule, newCssModule, replaceClassNameReducer);
  };

  return replaceMapper;
};
export var useClasses = function useClasses() {
  for (var _len = arguments.length, cssModules = new Array(_len), _key = 0; _key < _len; _key++) {
    cssModules[_key] = arguments[_key];
  }

  if (cssModules[0] === undefined) {
    throw new Error('Base css module is undefined. This is not allowed');
  }

  return React.useMemo(function () {
    var normalizedCssModuleList = _filterInstanceProperty(cssModules).call(cssModules, function (el) {
      return el !== undefined;
    });

    return _reduceInstanceProperty(normalizedCssModuleList).call(normalizedCssModuleList, function (last, next) {
      if (typeof next === 'function') {
        return next(last);
      }

      return next;
    });
  }, cssModules);
};
export var useClassesMapper = function useClassesMapper(mapper) {
  var _context4;

  for (var _len2 = arguments.length, cssModules = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    cssModules[_key2 - 1] = arguments[_key2];
  }

  if (typeof mapper !== 'function') {
    throw new Error("Expected first argument to be a mapper function. This should be the result of calling \n#compose or #replace");
  }

  return React.useMemo(function () {
    var normalizedCssModuleList = _filterInstanceProperty(cssModules).call(cssModules, function (el) {
      return el !== undefined;
    });

    return _reduceInstanceProperty(normalizedCssModuleList).call(normalizedCssModuleList, function (lastMapper, next) {
      return function (defaultCssModule) {
        if (typeof next === 'function') {
          return next(lastMapper(defaultCssModule));
        }

        return next;
      };
    }, mapper);
  }, _concatInstanceProperty(_context4 = [mapper]).call(_context4, cssModules));
};
export var useClassesCompose = function useClassesCompose(newClasses) {
  var _context5;

  return React.useCallback(compose(newClasses), _flatInstanceProperty(_context5 = _Object$entries(newClasses)).call(_context5));
};